var _g, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.28443 -.28443)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 2000,
    "data-background-color": "#ffffff",
    viewBox: "0 0 334 334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.0475 .0475)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 333.9,
    height: 333.9,
    viewBox: "0 0 333.90454557049503 333.90454557049503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)), /*#__PURE__*/React.createElement("svg", _extends({
    width: 333.9,
    height: 333.9,
    viewBox: "0 0 333.90454557049503 333.90454557049503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ee3e38",
    stroke: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 166.95c0-92.205 74.747-166.95 166.95-166.95s166.95 74.747 166.95 166.95c0 92.205-74.747 166.95-166.95 166.95-92.205 0-166.95-74.747-166.95-166.95zm166.95 156.28c86.308 0 156.27-69.966 156.28-156.28 0-86.308-69.966-156.27-156.28-156.27-86.308 0-156.27 69.966-156.27 156.27s69.966 156.27 156.27 156.28z",
    "data-fill-palette-color": "tertiary"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.95,
    cy: 166.95,
    rx: 160.27,
    ry: 160.27,
    strokeWidth: 0,
    "data-fill-palette-color": "tertiary"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.93 71.173)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    viewBox: "0 0 132.0346318062891 191.55844122715712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    viewBox: "0 0 132.0346318062891 191.55844122715712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    viewBox: "0 0 132.0346318062891 191.55844122715712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    viewBox: "0 0 132.0346318062891 191.55844122715712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    viewBox: "0 0 132.0346318062891 191.55844122715712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    viewBox: "0 0 132.0346318062891 191.55844122715712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 132.03,
    height: 191.56,
    "data-palette-color": "#ffffff",
    viewBox: "1.95 -34.65 24.400000000000002 35.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wordmark-text-0",
    d: "m7.53-34.65h18.82v22.17q0 3.03-0.92 5.48-0.93 2.45-2.72 4.17-1.78 1.73-4.37 2.65-2.59 0.93-5.91 0.93-3.35 0-5.79-0.86-2.44-0.87-4.69-2.39l3.13-5.05q1.77 1.22 3.32 1.71t3.53 0.49q2.67 0 4.46-1.71 1.79-1.72 1.79-5.32v-16.27h-10.65v-6z",
    fill: "#fff",
    "data-fill-palette-color": "quaternary"
  }))))))))))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 333.9,
    height: 333.9,
    fill: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f01135e5e21ac0cc3fbbfb1f8e52353b.svg";
export { ForwardRef as ReactComponent };